export default __webpack_public_path__ + "static/media/search.899b92d3.svg";